import React from 'react'

function Archive() {

  return (
    <div className='archive__wrapper'>
        <div className='archive__container'>
           <p>В данный момент нет архивированных курсов</p>
        </div>
    </div>
  )
}

export default Archive
